var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2261 2.25C6.84607 2.25 2.47607 6.62 2.47607 12V19C2.47607 20.52 3.70607 21.75 5.22607 21.75H12.2261C17.6061 21.75 21.9761 17.38 21.9761 12C21.9761 6.62 17.6061 2.25 12.2261 2.25ZM12.2261 20.25H5.22607C4.53607 20.25 3.97607 19.69 3.97607 19V12C3.97607 7.45 7.67607 3.75 12.2261 3.75C16.7761 3.75 20.4761 7.45 20.4761 12C20.4761 16.55 16.7761 20.25 12.2261 20.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2261 10.25H10.2261C9.81607 10.25 9.47607 10.59 9.47607 11C9.47607 11.41 9.81607 11.75 10.2261 11.75H11.2261C11.3661 11.75 11.4761 11.86 11.4761 12V17C11.4761 17.41 11.8161 17.75 12.2261 17.75C12.6361 17.75 12.9761 17.41 12.9761 17V12C12.9761 11.04 12.1861 10.25 11.2261 10.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2261 6.25C11.8161 6.25 11.4761 6.59 11.4761 7V8C11.4761 8.41 11.8161 8.75 12.2261 8.75C12.6361 8.75 12.9761 8.41 12.9761 8V7C12.9761 6.59 12.6361 6.25 12.2261 6.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.1fd79aac64a26bb8a126d30b06a0c830.svg";
export { ForwardRef as ReactComponent };